import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { DashboardEntity } from './dashboard.entity';
import { RbacRoleEntity } from './rbac-role.entity';

@Index('idx_dashboard_role_unique', ['dashboardId', 'roleId'], {
	unique: true,
})
@Index('idx_dashboard_role_dashboard', ['dashboardId'])
@Index('idx_dashboard_role_role', ['roleId'])
@Entity('dashboard_role')
export class DashboardRoleEntity extends BaseEntity {
	@Column('int', { name: '_fk_dashboard__id', unsigned: true })
	public dashboardId!: number;

	@Column('int', { name: '_fk_rbac_role__id', unsigned: true })
	public roleId!: number;

	/**
	 * PD-16790. This dashboard is the default for users holding the role
	 * (directly; parent roles are not followed, matching how sharing works).
	 * At most one per role: setting it clears the flag on the role's other
	 * rows. Dropped when the role is unshared from the dashboard.
	 */
	@Column({
		type: 'boolean',
		name: 'isDefault',
		width: 1,
		default: () => "'0'",
	})
	public isDefault!: boolean;

	@ManyToOne(() => DashboardEntity, (dashboard) => dashboard.sharedRoles, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_dashboard__id', referencedColumnName: 'id' }])
	public dashboard!: DashboardEntity;

	@ManyToOne(() => RbacRoleEntity, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_rbac_role__id', referencedColumnName: 'id' }])
	public role!: RbacRoleEntity;
}
